module.exports = __webpack_public_path__ + "media/icons/pierwsza-rejestracja@2x-2e6bc118.png";